import React, {useEffect, useMemo, useState} from "react"
import PropTypes from "prop-types"
import ReactInputMask from "react-input-mask"
import TextFieldInput from "../text-field-input"
import {validateCPF, validateCNPJ} from "../../../utils/validate-cpf-cnpj/validate-cpf-cnpj"

const CPF_MASK = "999.999.999-99"
const CNPJ_MASK = "99.999.999/9999-99"

const CpfCnpjMaskedInput = ({value, onChange, maskType = "cpfCnpj", InputLabelProps, disabled, ...props}) => {
    const [error, setError] = useState("")

    const mask = useMemo(() => {
        if (maskType === "cpf") return CPF_MASK
        if (maskType === "cnpj") return CNPJ_MASK
        return CNPJ_MASK
    }, [maskType])

    useEffect(() => {
        if (!maskType) return
        const digits = (value || "").replace(/\D/g, "")
        const expectedLength =
            maskType === "cpf" ? 11 : maskType === "cnpj" ? 14 : 14

        if (!digits.length || digits.length < expectedLength) {
            setError("")
            return
        }

        if ((maskType === "cpf" || maskType === "cpfCnpj") && expectedLength === 11 && !validateCPF(digits)) {
            setError("CPF inválido")
            return
        }

        if ((maskType === "cnpj" || maskType === "cpfCnpj") && expectedLength === 14 && !validateCNPJ(digits)) {
            setError("CNPJ inválido")
            return
        }

        setError("")
    }, [maskType, value])

    return (
        <ReactInputMask mask={mask} value={value} onChange={onChange} maskChar="" disabled={disabled}>
            {(inputMaskProps) => (
                <TextFieldInput
                    {...props}
                    value={value}
                    onChange={onChange}
                    error={Boolean(error)}
                    helperText={error || undefined}
                    {...inputMaskProps}
                    InputLabelProps={InputLabelProps}
                />
            )}
        </ReactInputMask>
    )
}

CpfCnpjMaskedInput.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    maskType: PropTypes.oneOf(["cpf", "cnpj", "cpfCnpj"]),
    InputLabelProps: PropTypes.object,
    disabled: PropTypes.bool,
}

export default CpfCnpjMaskedInput
